import React, { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import Checkbox from '@lib/inputs/Checkbox';

import { IVoterRegistrationFormValues } from '../voterRegistrationTypes';
import useVoterRegistration from '../useVoterRegistration';
import { VoterRegistrationFormError } from '../VoterRegistrationFormError';

function RegistrationReasonSection() {
    const intl = useIntl();
    const {
        watch,
        formState: { errors },
        setValue,
        getValues,
        trigger,
    } = useFormContext();

    const { VOTER_REGISTRATION_CHOICES } = useVoterRegistration();

    const handleFieldChange = (name: keyof IVoterRegistrationFormValues, value: any) => {
        setValue(name, value, {
            shouldValidate: true,
            shouldDirty: true,
        });
        trigger(['politicalParty', 'otherPoliticalParty', 'votingInformationChanged']);
    };

    return (
        <>
            <FormattedMessage id="voterRegistration.form.reasonForRegistering.header" tagName="h2" />
            <fieldset id="registrationReason-section" className="gi-radio_buttons">
                <legend className="required-true">
                    <FormattedMessage id="voterRegistration.form.reasonForRegistering.selectReason" />
                </legend>
                <AlertMessage
                    type={'info'}
                    content={
                        <>
                            <FormattedMessage
                                id="voterRegistration.form.reasonForRegistering.alert.1"
                                values={{ strong: (chunks: any) => <strong>{chunks}</strong> }}
                            />
                            <br />
                            <FormattedMessage
                                id="voterRegistration.form.reasonForRegistering.alert.2"
                                values={{ strong: (chunks: any) => <strong>{chunks}</strong> }}
                            />
                        </>
                    }
                    showIcon={true}
                    icon={'info-circle'}
                />
                {VOTER_REGISTRATION_CHOICES.REGISTRATION_REASON.map(item => {
                    return (
                        <Fragment key={item.value}>
                            <Checkbox
                                label={{
                                    text: intl.formatMessage({ id: item.text, defaultMessage: item.text }),
                                }}
                                inputData={{
                                    classes: ['margin-top-4'],
                                    id: item.value,
                                    name: 'registrationReason',
                                    valueToPass: item.value,
                                    checked: watch('registrationReason')?.some(val => val === item.value),
                                }}
                                inputActions={{
                                    handleFieldChange: (checked: boolean, value: string) => {
                                        const existingValues = getValues('registrationReason') || [];
                                        handleFieldChange(
                                            'registrationReason',
                                            checked
                                                ? [...existingValues, value].filter((v, i, arr) => arr.indexOf(v) === i)
                                                : existingValues.filter(val => val !== value),
                                        );
                                    },
                                }}
                            />
                        </Fragment>
                    );
                })}
                <VoterRegistrationFormError
                    name="registrationReason"
                    data-testid="registrationReason-error"
                    hasError={!!errors.registrationReason}
                    messageId={errors.registrationReason?.message}
                />
            </fieldset>
        </>
    );
}

export default RegistrationReasonSection;
